import * as React from "react";
import clsx from "clsx";
const Container = React.forwardRef(function Container2(props, ref) {
  const { children, maxWidth, className } = props;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: clsx(
        "container",
        {
          ["container--max-width-".concat(props.maxWidth)]: maxWidth
        },
        className
      ),
      ref
    },
    children
  );
});
export {
  Container
};
